module.exports = __webpack_public_path__ + "static/HTH0-cd607e93499336de10fee4cbf328772e.png";